"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTransferTotalCostValue = void 0;
const calculateTransferTotalCostValue = (transfer_line) => {
    let val = 0;
    if (transfer_line?.vehicle?.vehicle?.id) {
        val += transfer_line?.vehicle?.cost * transfer_line?.vehicle?.quantity;
    }
    return val;
};
exports.calculateTransferTotalCostValue = calculateTransferTotalCostValue;
